module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5K92F"))).then(() => parcelRequire('hEqeo'));